
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'data-privacy-request-ui',
  currentProjectVersion: 'static-1.5555',
  depVersions: {
  "data-privacy-request-ui": "static-1.5555",
  "data-fetching-client": "static-1.9698",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8046",
  "hub-http-shared-msw-handlers": "static-1.10035",
  "hubspot-dlb": "static-2.1854",
  "HubStyleTokens": "static-2.11504",
  "I18n": "static-7.1631",
  "jasmine-runner": "static-1.6495",
  "privacy-center-public-service-types": "static-1.4818",
  "quartz": "static-1.7069",
  "react-dlb": "static-1.79",
  "ui-components-test-utils": "static-1.5641",
  "UIComponents": "static-3.8450",
  "webpack-env": "static-1.54",
  "apollo-stack-hubspot": "static-3.86",
  "foundations-assets": "static-1.4900",
  "foundations-components": "static-1.7994",
  "foundations-components-test-utils": "static-1.5477",
  "foundations-theming": "static-1.4451",
  "hub-http": "static-1.6254",
  "quartz-config": "static-1.847",
  "quartz-core": "static-1.6288",
  "quartz-routing": "static-1.499",
  "quick-fetch": "static-1.3941",
  "raven": "static-3.5925",
  "react": "static-7.186",
  "react-rhumb": "static-1.16705",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11180",
  "usage-tracker": "static-1.7379",
  "usage-tracker-anonymous": "static-1.5796",
  "usage-tracker-core": "static-1.7229",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4132",
  "immutable": "static-2.79",
  "metrics-js": "static-1.9637",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3424",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3346",
  "quartz-webpack": "static-1.3293",
  "bend-plugin-quartz-routing": "static-1.147",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.82",
  "HeadJS": "static-2.764",
  "framer-motion": "static-1.72",
  "hs-test-utils-bend-plugin": "static-1.3157",
  "msw": "static-1.39",
  "testing-library": "static-1.152",
  "ts-schema": "static-1.4105",
  "i18n-data": "static-1.221",
  "moment-timezone": "static-5.83",
  "react-utils": "static-2.5369",
  "StyleGuideUI": "static-3.487",
  "jasmine": "static-4.4358",
  "rpc-client-utils": "static-1.4684",
  "HubStyle": "static-2.11811",
  "ui-addon-draggable": "static-3.4794",
  "cssUtils": "static-1.798",
  "hs-story-utils": "static-1.9455",
  "icons": "static-2.650",
  "react-select-plus": "static-1.105",
  "react-virtualized": "static-2.99",
  "ui-images": "static-2.1160",
  "bend-plugin-foundations-components": "static-1.4263",
  "floating-ui": "static-1.56",
  "foundations-theming-specialty": "static-1.2167",
  "react-aria": "static-1.66",
  "react-create-root-preference": "static-1.29",
  "tanstack-table": "static-1.55",
  "trellis-assets": "static-1.2036",
  "ui-fonts": "static-1.766",
  "foundations-components-legacy": "static-1.1019",
  "bend-plugin-foundations-theming": "static-1.2934",
  "foundations-theming-base": "static-1.3436",
  "stylex": "static-1.33",
  "hs-locale-management": "static-1.106",
  "dispatcher": "static-1.137",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.838",
  "hubspotter-http": "static-1.4676",
  "mobile-manifest-mixins": "static-1.538",
  "module-federation": "static-1.23",
  "quartz-auth": "static-1.744",
  "quartz-head": "static-1.734",
  "quartz-i18n": "static-1.744",
  "quartz-test": "static-1.744",
  "quartz-tracking": "static-1.448",
  "usage-tracker-container": "static-1.7369",
  "csstype": "static-1.50",
  "web-vitals": "static-1.6",
  "react-input-autosize": "static-2.17",
  "bender-build-tools": "static-1.3227",
  "bend-plugin-chirp-manifest": "static-1.94",
  "chirp-fetch": "static-1.1919",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-flip-move": "static-1.70",
  "sassPrefix": "static-1.156",
  "hubspotter-http-shared-msw-handlers": "static-1.10033",
  "usage-tracker-session-replay": "static-1.5065",
  "amplitude-session-replay-browser": "static-1.60"
},
  depPathPrefixes: {
  "data-privacy-request-ui": "/data-privacy-request-ui/static-1.5555",
  "data-fetching-client": "/data-fetching-client/static-1.9698",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8046",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10035",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyleTokens": "/HubStyleTokens/static-2.11504",
  "I18n": "/I18n/static-7.1631",
  "jasmine-runner": "/jasmine-runner/static-1.6495",
  "privacy-center-public-service-types": "/privacy-center-public-service-types/static-1.4818",
  "quartz": "/quartz/static-1.7069",
  "react-dlb": "/react-dlb/static-1.79",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5641",
  "UIComponents": "/UIComponents/static-3.8450",
  "webpack-env": "/webpack-env/static-1.54",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.86",
  "foundations-assets": "/foundations-assets/static-1.4900",
  "foundations-components": "/foundations-components/static-1.7994",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5477",
  "foundations-theming": "/foundations-theming/static-1.4451",
  "hub-http": "/hub-http/static-1.6254",
  "quartz-config": "/quartz-config/static-1.847",
  "quartz-core": "/quartz-core/static-1.6288",
  "quartz-routing": "/quartz-routing/static-1.499",
  "quick-fetch": "/quick-fetch/static-1.3941",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.186",
  "react-rhumb": "/react-rhumb/static-1.16705",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11180",
  "usage-tracker": "/usage-tracker/static-1.7379",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5796",
  "usage-tracker-core": "/usage-tracker-core/static-1.7229",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "immutable": "/immutable/static-2.79",
  "metrics-js": "/metrics-js/static-1.9637",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3424",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3346",
  "quartz-webpack": "/quartz-webpack/static-1.3293",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.147",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.82",
  "HeadJS": "/HeadJS/static-2.764",
  "framer-motion": "/framer-motion/static-1.72",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3157",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.152",
  "ts-schema": "/ts-schema/static-1.4105",
  "i18n-data": "/i18n-data/static-1.221",
  "moment-timezone": "/moment-timezone/static-5.83",
  "react-utils": "/react-utils/static-2.5369",
  "StyleGuideUI": "/StyleGuideUI/static-3.487",
  "jasmine": "/jasmine/static-4.4358",
  "rpc-client-utils": "/rpc-client-utils/static-1.4684",
  "HubStyle": "/HubStyle/static-2.11811",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4794",
  "cssUtils": "/cssUtils/static-1.798",
  "hs-story-utils": "/hs-story-utils/static-1.9455",
  "icons": "/icons/static-2.650",
  "react-select-plus": "/react-select-plus/static-1.105",
  "react-virtualized": "/react-virtualized/static-2.99",
  "ui-images": "/ui-images/static-2.1160",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4263",
  "floating-ui": "/floating-ui/static-1.56",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2167",
  "react-aria": "/react-aria/static-1.66",
  "react-create-root-preference": "/react-create-root-preference/static-1.29",
  "tanstack-table": "/tanstack-table/static-1.55",
  "trellis-assets": "/trellis-assets/static-1.2036",
  "ui-fonts": "/ui-fonts/static-1.766",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1019",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2934",
  "foundations-theming-base": "/foundations-theming-base/static-1.3436",
  "stylex": "/stylex/static-1.33",
  "hs-locale-management": "/hs-locale-management/static-1.106",
  "dispatcher": "/dispatcher/static-1.137",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.838",
  "hubspotter-http": "/hubspotter-http/static-1.4676",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.538",
  "module-federation": "/module-federation/static-1.23",
  "quartz-auth": "/quartz-auth/static-1.744",
  "quartz-head": "/quartz-head/static-1.734",
  "quartz-i18n": "/quartz-i18n/static-1.744",
  "quartz-test": "/quartz-test/static-1.744",
  "quartz-tracking": "/quartz-tracking/static-1.448",
  "usage-tracker-container": "/usage-tracker-container/static-1.7369",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.6",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "bender-build-tools": "/bender-build-tools/static-1.3227",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.94",
  "chirp-fetch": "/chirp-fetch/static-1.1919",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-flip-move": "/react-flip-move/static-1.70",
  "sassPrefix": "/sassPrefix/static-1.156",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10033",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5065",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60"
}
};
